
import React from 'react'
import { LoaderScreen } from '../../componentes/LoaderScreenComponente'

function PaginaLoading() {
  return (
    <LoaderScreen></LoaderScreen>
  )
}

export default PaginaLoading